import { lazy, Suspense } from 'react';
import { useAuth } from '../../context/AuthContext';
import TempSuperAdminDashboard from './TempSuperAdminDashboard';
import { useEffectiveRoleName } from './Home';

const DepartmentManagerDashboardPage = lazy(
  () => import('../../features/epc/dashboards/DepartmentManagerDashboard/DepartmentManagerDashboardPage'),
);
const PmoPortfolioDashboardPage = lazy(
  () => import('../../features/epc/dashboards/PmoPortfolioDashboard/PmoPortfolioDashboardPage'),
);

/**
 * /dashboard landing. EPC Department Managers land on the Department Command
 * Center, EPC PMO users on the Portfolio Command Center; everyone else keeps
 * the existing default dashboard.
 */
export default function RoleLandingDashboard() {
  const { activeDepartment } = useAuth();
  const roleLower = useEffectiveRoleName().toLowerCase();
  const isEpc = (activeDepartment || '').toUpperCase() === 'EPC';

  const fallback = <div className="p-6 text-slate-500">Loading dashboard…</div>;

  if (isEpc && roleLower.includes('pmo')) {
    return (
      <Suspense fallback={fallback}>
        <PmoPortfolioDashboardPage />
      </Suspense>
    );
  }

  if (isEpc && roleLower.includes('manager') && !roleLower.includes('head')) {
    return (
      <Suspense fallback={fallback}>
        <DepartmentManagerDashboardPage />
      </Suspense>
    );
  }

  return <TempSuperAdminDashboard />;
}
